/**
 * @file src/components/VidButtonBank/VidButtonBank.tsx
 * @exports VidButtonBank
 * @summary Button bank for vID Web containing the accessibility widget and support button, positioned along the right edge of the screen.
 */

import { FC } from "react";

import { useShowSupportButton } from "src/hooks";

import { AccessibilityButton } from "./AccessibilityButton";
import { SupportBankButton } from "./SupportBankButton";
import { BottomButton, ButtonBankWrapper, SingleButton, TopButton } from "./VidButtonBank.styles";

interface VidButtonBankProps {
	buttonOffset?: string;
}

/** Fixed button bank on the right edge of vID pages, always showing the accessibility button and conditionally the support button. */
export const VidButtonBank: FC<VidButtonBankProps> = ({ buttonOffset }) => {
	const showSupport = useShowSupportButton();

	return (
		<ButtonBankWrapper $buttonOffset={buttonOffset}>
			<AccessibilityButton ButtonSlot={showSupport ? TopButton : SingleButton} />
			{showSupport && <SupportBankButton ButtonSlot={BottomButton} />}
		</ButtonBankWrapper>
	);
};
